<template>
  <div>
    <div v-for="info in drug.infoPrices">
      <p><strong>{{ info.supplier.title }}</strong> - цена: <strong>{{ info.price }}</strong></p>
      <p v-if="info?.extra_data?.min_price">минимальная цена:
        <strong>{{ info.extra_data.min_price }}</strong></p>
      <p v-if="info?.extra_data?.in_stores">в наличии в аптеках:
        <strong>{{ info.extra_data.in_stores }}</strong></p>
      <p class="text-muted">{{ printDate(info.updated_at) }}</p>
    </div>
  </div>
</template>

<script>

export default {
  props: ['drug']
}

</script>
